// extracted by mini-css-extract-plugin
export var chatHtmlText = "_nr-2";
export var chatLink = "_nr-0";
export var chatText = "_nr-1";